import React, { FunctionComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Routes } from '../../../../common/enums/Routes';
import RegularButton from '../../../../components/RegularButton';

const CandidateFormPane: FunctionComponent<RouteComponentProps> = ({ history }) => (
  <div>
    <RegularButton
      onClick={() => history.push(Routes.CandidateFormPreview)}
      textIntlId="candidateFormPane.preview"
      defaultMessage="Preview candidate form"
    />
  </div>
);

export default withRouter(CandidateFormPane);
